import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { InnerPrimaryButton } from 'cstar-react-primitives/lib/redux-form/buttons/PrimaryButton';
import { InnerSecondaryButton } from 'cstar-react-primitives/lib/redux-form/buttons/SecondaryButton';
import { SubHeader } from 'cstar-react-primitives/lib/redux-form/layout/Container';
import { LinkExternalWithHref } from 'cstar-react-primitives/lib/redux-form/LinkExternalWithHref';
import Markdown from 'markdown-to-jsx';

import ModalFooter from '../modal/ModalFooter';
import ModalHeader from '../modal/ModalHeader';
import { ModalContainer } from '../modal/ModalWrapper';
import ModalContent, { ModalContentInner } from '../modal/ModalContent';

import { cardholderAgreementModalMessages } from './consentMessages';
import { getCardholderAgreementModalContent } from './consentSelectors';


export const CARDHOLDER_AGREEMENT_MODAL_ID = 'cardholder-agreement';

export const CardholderAgreementModal = ({
    intl,
    cashbotName,
    modalId,
    cardholderAgreementContent,
    onAgree,
    onDisagree
}) => {
    const [buttonsDisabled, setButtonsDisabled] = useState(true);

    const modalProps = {
        modalId,
        cashbotName,
        className: 'payment-cardholder-agreement__modal',
        contentLabel: cardholderAgreementModalMessages.cardholderAgreementSubtitle,
        isOpen: true,
        handleScrollToBottom: () => setButtonsDisabled(false)
    };
    const promptProps = {
        id: 'cardholder-agreement-prompt',
        className: 'payment-cardholder-agreement__modal-prompt'
    };
    const disagreeButtonProps = {
        cashbotName,
        type: 'button',
        onClick: onDisagree,
        btnText: intl.formatMessage(cardholderAgreementModalMessages.cardholderAgreementDisagreeButton),
        ariaDescribedBy: promptProps.id,
        atts: {
            disabled: buttonsDisabled
        }
    };
    const agreeButtonProps = {
        cashbotName,
        type: 'button',
        onClick: onAgree,
        btnText: intl.formatMessage(cardholderAgreementModalMessages.cardholderAgreementAgreeButton),
        ariaDescribedBy: promptProps.id,
        atts: {
            disabled: buttonsDisabled
        }
    };

    return (
        <ModalContainer {...modalProps}>
            <ModalHeader headerText={cardholderAgreementModalMessages.cardholderAgreementTitle} />
            <ModalContent>
                <SubHeader heading={intl.formatMessage(cardholderAgreementModalMessages.cardholderAgreementSubtitle)} />
                <ModalContentInner>
                    <Markdown
                        options={{
                            overrides: {
                                
                                a: {
                                    component: LinkExternalWithHref
                                }
                            }
                        }}
                    >
                        {cardholderAgreementContent}
                    </Markdown>
                </ModalContentInner>
                <div {...promptProps}>
                    {intl.formatMessage(cardholderAgreementModalMessages.cardholderAgreementPromptText)}
                </div>
            </ModalContent>
            <ModalFooter>
                <div className="btn-row">
                    <InnerSecondaryButton {...disagreeButtonProps} />
                    <InnerPrimaryButton {...agreeButtonProps} />
                </div>
            </ModalFooter>
        </ModalContainer>
    );
};

CardholderAgreementModal.defaultProps = {
    cashbotName: 'cardholder-agreement',
    modalId: CARDHOLDER_AGREEMENT_MODAL_ID,
    cardholderAgreementContent: ''
};

CardholderAgreementModal.propTypes = {
    
    intl: intlShape.isRequired,
    
    cardholderAgreementContent: PropTypes.string,
    
    modalId: PropTypes.string,
    cashbotName: PropTypes.string,
    onAgree: PropTypes.func.isRequired,
    onDisagree: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    cardholderAgreementContent: getCardholderAgreementModalContent(state)
});

export default connect(mapStateToProps)(injectIntl(CardholderAgreementModal));
